import * as constants from '../constants';

const stableSort = (arr, compare) => arr
    .map((item, index) => ({ item, index }))
    .sort((a, b) => compare(a.item, b.item) || a.index - b.index)
    .map(({ item }) => item);

function getCategoryName(option) {
    if (option.custom == null) {
        return null;
    }

    if (option.custom['fun-featured'] === 'true') {
        return this.$t('FEATURED');
    }

    if (option.custom['fun-featured-default'] === 'true') {
        return this.$t('FEATURED');
    }

    return option.custom['fun-category'];
}

/**
 * Gets attach packs of a controller.
 */
// eslint-disable-next-line import/prefer-default-export
export function attachPacksOf(controller) {
    let placement = controller.state.find((s) => constants.PLACEMENT_PACKS.includes(s.placement.code));

    if (placement == null) {
        return [];
    }

    placement = placement.placement;

    const components = [];

    placement.components.forEach((c) => {
        if (c.placeholder) {
            return;
        }

        const pic = c.placementIndependentCode;

        // Is it selected.
        let quantity = 0;
        const icons = [];

        controller.state.forEach((s) => {
            if (s.placement.code !== constants.PLACEMENT_AP_PREVIEW && s.placement.code !== constants.PLACEMENT_AP_PREVIEW_SECONDARY) {
                if (s.component.placementIndependentCode === pic) {
                    quantity += s.component.quantityMultiplier || 1;
                    icons.push(
                        `https://api.images.drivecommerce.com/api/v1/image/funko/CZ-Icon-v2-${s.component.custom['fun-sku']}?fmt=png-alpha`,
                    );
                }
            }
        });

        if (quantity === 0 && !controller.isAllowed(c)) {
            return;
        }

        const price = controller.getPrice(c);

        let image = `https://api.images.drivecommerce.com/api/v1/image/funko/CZ-Icon-v2-${c.custom['fun-sku']}?fmt=webp&qlt=40&rwid=562&rhei=562`;

        if (c.custom?.['fun-pack-tile']) {
            image = `${c.custom?.['fun-pack-tile']}?fmt=webp&qlt=40&rwid=562&rhei=562`;
        }

        components.push({
            code: c.code,
            quantity,
            placementIndependentCode: pic,
            component: c,
            price,
            category: getCategoryName(c) || 'Uncategorized',
            isNew: c.custom['fun-new'] === 'true' || c.custom['fun-new-default'] === 'true',
            canAdd: controller.isAvailable(c, quantity),
            image,
            type: 'attachpack',
            icon: icons,
            branding: c.custom['fun-branding'],
        });
    });

    const total = components.reduce((current, c) => current + (c.quantity ?? 0), 0);

    if (total >= constants.ATTACH_PACKS_LIMIT) {
        components.forEach((c) => {
            c.canAdd = false;
        });
    }

    const sorted = stableSort(components, (a, b) => {
        if (a.category < b.category) {
            return -1;
        }

        if (a.category > b.category) {
            return 1;
        }

        return 0;
    });

    return sorted;
}
